import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { CurrencyColumnModel } from '~components/dynamic-table/models/column-types/currency-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { CurrencyPipe } from '~core/pipes/currency.pipe';
import { FormControlPipe } from '~core/pipes/form-control.pipe';
import { OptionalType } from '~shared/core/types/optional.type';
import { CurrencyInputComponent } from '../../../form/currency-input/currency-input.component';

@Component({
    selector: 'arc-currency-column',
    templateUrl: './currency-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [CurrencyInputComponent, ReactiveFormsModule, FormControlPipe, CurrencyPipe]
})
export class CurrencyColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> implements OnInit {
    get currColumnModel(): CurrencyColumnModel {
        return this.columnModel as CurrencyColumnModel;
    }

    get currencyId(): string | undefined {
        const currencyIdFn = this.currColumnModel.currencyId;
        return currencyIdFn ? currencyIdFn(this.item) : undefined;
    }

    get currencyIsoCode(): string | undefined {
        const currencyIsoCodeFn = this.currColumnModel.currencyIsoCode;
        return currencyIsoCodeFn ? currencyIsoCodeFn(this.item) : undefined;
    }

    get value(): OptionalType<number> {
        return this.getItemValue(this.columnModel.propertyName);
    }

    get hasValue(): boolean {
        return typeof this.value === 'number';
    }
}
